import { useGetFile } from '@shared/hooks/use-get-file';
import * as costCenterApi from '@api/cost-centers';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useCurrentUser } from '@shared/hooks';
import { useParams } from 'react-router-dom';
import { toast } from '@ui/components';

const ITEMS_NUMBER = 10;

export const useCostCenterInvoices = () => {
  const { costCenterId } = useParams<{ costCenterId: string }>();
  const { companyId } = useCurrentUser();
  const { t } = useTranslation();

  const { data, isLoading } = useQuery({
    queryKey: ['cost-center-invoices', costCenterId],
    queryFn: () => costCenterApi.getInvoicesList(costCenterId!, ITEMS_NUMBER),
    enabled: !!costCenterId,
  });

  const { handleGetFile: downloadFile, isLoading: isDownloadingFile } = useGetFile({
    onSuccess: () => {
      toast.success(t('COST_CENTER.INVOICES.DOWNLOAD_SUCCESS'));
    },
  });

  return {
    invoices: data ?? [],
    isDownloadingFile,
    downloadFile,
    costCenterId,
    companyId,
    isLoading,
  };
};
